type JobExecutable = () => void | Promise<void>;

export default class Job {
    /** cb将获得resolve和reject两个函数 */
    public static promise(cb: (resolve?: any, reject?: any) => any) {
        return new Job(() => {
            return new Promise(cb);
        });
    }
    public cb: JobExecutable;
    public constructor(cb: JobExecutable) {
        this.cb = cb;
    }
    public execute() {
        return this.cb();
    }
}
